export const colocation = {
  title: 'Colocation',
  subtitle: 'Ospita il tuo hardware nella nostra struttura all\'avanguardia',
  features: {
    datacenter: {
      title: 'Data Center Moderno',
      description: 'Struttura all\'avanguardia con sicurezza avanzata'
    },
    connectivity: {
      title: 'Connettività Premium',
      description: 'Rete ridondante 10G a bassa latenza'
    },
    security: {
      title: 'Sicurezza 24/7',
      description: 'Monitoraggio continuo e controllo accessi'
    },
    location: {
      title: 'Ubicazione',
      description: 'Via Caldera 21, Milano - Seeweb'
    }
  }
};